    const NationalCodeValidation = (value:any) => 
    {
        if (!/^\d{10}$/.test(value))
            return false;
            
        var check = +value[9];
        var sum = 0;
        var i;
        for (i = 0; i < 9; ++i) 
        {
            sum += +value[i] * (10 - i);
        }
        sum %= 11;
        
        return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
            
    }

    const PhoneNumberValidation = (value:any) => 
    {
        var phonenoReg = /(0|\+98)?([ ]|-|[()]){0,2}9[0-9]([ ]|-|[()]){0,2}(?:[0-9]([ ]|-|[()]){0,2}){8}/ig;
        if(value.match(phonenoReg))
        {
            return true;
        }
        else 
        {
            return false;
        }        
    }

export{NationalCodeValidation,PhoneNumberValidation}